/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    /*
     Creates a filters sort by drop down

     Usage example:
     <filters-sort-by
         data-on-sort-option-selected="FavProductsCtrl.sortOptionSelected(selectedSortOption)"
         data-selected-code="FavProductsCtrl.selectedSortByCode">
     </filters-sort-by>

     FavProductsCtrl.sortOptionSelected method example:
     vm.sortOptionSelected = function(selectedSortOption) {
         alert(selectedSortOption.display_name);
     }

     */
    app.directive('dropdown', [function () {

        return {
            // must be an element (can not be used as an attribute or ...)
            restrict: 'E',
            replace: true,
            scope: {
                isResultsPage: '@',
                isFavoritedProductsPage: '@',
                onOptionSelected: '&',
                title: '@',
                menuIcon: '@',
                options: '='
            },
            controller: [
                '$scope',
                function (
                    $scope
                ) {

                    $scope.$watch('options', function (newValue) {
                        if (newValue && newValue.length > 0 && !$scope.title) {
                            $scope.selectedOption = newValue[0];
                        }
                    });

                    /**
                     * Gets the selected option and calls the onOptionSelected call back
                     * and passes the selected option in it
                     *
                     * @param {Object} option - The option object that was selected
                     */
                    $scope.optionSelected = function (option) {
                        $scope.selectedOption = option;
                        $scope.onOptionSelected({'selectedOption': $scope.selectedOption});

                    };

                }],
            template: require('@app/shared/inputs/dropdown/dropdownView.html')
        };
    }]);
})(angular);